var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-7"},[_c('bdc',{attrs:{"url_data":_vm.url_data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }